export enum AutoInstalledState
{
    Auto = 0,
    Installed = 1,
    NotInstalled = 2
}

export namespace AutoInstalledState
{

    export function toListItems() 
    {
        return [ 
            { value: AutoInstalledState.Auto, title: 'Auto' },
            { value: AutoInstalledState.Installed, title: 'Installed' },
            { value: AutoInstalledState.NotInstalled, title: 'Not Installed' }
         ];
    }

    export function toString( value: AutoInstalledState ) 
    {
        return toListItems().find( i => i.value == value )!.title;
    }
    
}